module.exports = __webpack_public_path__ + "fonts/TildaSans-Black.3534811.ttf";